import React, { useContext, useState } from "react";
import _ from "lodash";
import { Checkbox } from "antd";
// Helpers
import { FIELD_NAMES } from "constants/pricerTable";
import { toast } from "helpers/generalHelper";
// API
import { updateLiveOrUpdateTraderRow } from "api/pricerApi";
// Context
import { PricerContext } from "contexts/PricerContext";

const CheckBoxPricer = (props) => {
  const isAggData = props.node.group ? props.node.aggData : props.node.data;
  const field = props.colDef.field;
  const [isChecked, setIsChecked] = useState(Boolean(isAggData?.[field]));
  const {
    state: { pricerTablesData },
    setPricerData,
    setIsCellEditing,
    setRowEditingData,
  } = useContext(PricerContext);

  const onClickHandler = () => {
    setIsCellEditing(true);
    setRowEditingData(isAggData);

    setIsChecked((prev) => !prev);
    const prepareBody = {
      [FIELD_NAMES.SUMMARY_ID]: isAggData?.[FIELD_NAMES.SUMMARY_ID],
      [field]: +!isChecked,
    };

    updateLiveOrUpdateTraderRow(field, prepareBody)
      .then((res) => {
        if (field === FIELD_NAMES.LIVE) {
          const updatedData = _.unionBy(
            [...res.data.data],
            pricerTablesData,
            "id"
          ).sort((a, b) => a.id - b.id);
          setPricerData(updatedData);
        }
        const toastMessage =
          field === FIELD_NAMES.LIVE
            ? "Live Updated"
            : field === FIELD_NAMES.IS_AUTO_UPDATE_VOL
              ? res.data?.message
              : "Row Updated";
        toast(toastMessage, "success");
        setIsCellEditing(false);
        setRowEditingData(null);
      })
      .catch((err) => {
        setIsCellEditing(false);
        setRowEditingData(null);
      });
  };

  if (props.node?.level !== 0) return <></>;

  return (
    <div className="checkbox-cell" >
      <Checkbox disabled={!isAggData?.live_checkbox_enabled && field === FIELD_NAMES.LIVE
      } checked={isChecked} onChange={onClickHandler} />
    </div>
  );
};

export default CheckBoxPricer;
